import * as React from 'react';
const SvgCheck = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m8.333 11.9 5.228-5.235a.53.53 0 0 1 .387-.173q.214 0 .387.173a.53.53 0 0 1 .173.387.54.54 0 0 1-.173.387l-5.537 5.529a.65.65 0 0 1-.95 0l-2.183-2.175a.53.53 0 0 1-.173-.386q0-.214.173-.388a.53.53 0 0 1 .387-.173q.215 0 .387.173z'
            />
        </g>
    </svg>
);
export default SvgCheck;
